import Axios from "axios";

export default class WidgetService {
  static controllersCheck = async (object) => {
    let response = null;
    await Axios({
      crossDomain: true,
      dataType: "json",
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL_APIWIDGETCAROUSEL_HAZO_AI}v1/controllers_check/`,
      data: JSON.stringify(object)
    })
      .then((data) => {
        response = data.data;
      })
      .catch(() => {
        response = false;
      });

    return response;
  };

  static main = async (object) => {
    let response = null;
    await Axios({
      crossDomain: true,
      dataType: "json",
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL_APIWIDGETCAROUSEL_HAZO_AI}v1/main/`,
      data: JSON.stringify(object)
    })
      .then((data) => {
        response = data.data;
      })
      .catch(() => {
        response = false;
      });

    return response;
  };

  static configProject = async (object) => {
    let response = null;
    await Axios({
      crossDomain: true,
      dataType: "json",
      method: "GET",
      url: `${process.env.REACT_APP_BASE_URL_APIWIDGETCAROUSEL_HAZO_AI}v1/config_project/?carousel=${object.carousel}`,
    })
      .then((data) => {
        response = data.data;
      })
      .catch(() => {
        response = false;
      });

    return response;
  }

  static layoutAi = async (object) => {
    let response = null;
    await Axios({
      crossDomain: true,
      dataType: "json",
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL_API_HAZO_AI}v1/chatbot/layout/`,
      data: JSON.stringify(object)
    })
      .then((data) => {
        response = data.data;
      })
      .catch(() => {
        response = false;
      });

    return response;
  };

  static layoutApp = async (object) => {
    let response = null;
    await Axios({
      crossDomain: true,
      dataType: "json",
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL_API_HAZO_APP}v2/layout/`,
      data: JSON.stringify(object)
    })
      .then((data) => {
        response = data.data;
      })
      .catch(() => {
        response = false;
      });

    return response;
  };

}
